<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5.7" y="4.7" width="26.6" height="20.6" rx="1.3" stroke="currentColor" stroke-width="1.4"/>
<line x1="5.70557" y1="10.3567" x2="32.1519" y2="10.3567" stroke="currentColor"/>
<line x1="5.70557" y1="17.9282" x2="32.1519" y2="17.9282" stroke="currentColor"/>
<line x1="18.7961" y1="26" x2="18.7961" y2="10.8567" stroke="currentColor"/>
</svg>
